import * as types from "./actionTypes";
import minimaleEisenPerInfrastructuurApi from "../api/minimaleEisenPerInfrastructuurApi";
import * as constants from "../constants/DomainConstants";
import * as ajax from "./ajaxCounterActions";
import * as exception from "./exceptionActions";
import * as beads from "./beadActions";


// ----------------------------------------------------------------------------
export function minimaleEisenPerInfrastructuurLoaded(minimaleEisenPerInfrastructuur, errors, hasValidationErrors) {
	return {
		type: types.MINIMALE_EISEN_PER_INFRASTRUCTUUR_LOADED,
		body: {
			item: minimaleEisenPerInfrastructuur,
			errors: errors,
			hasValidationErrors
		}
	};
}

export function loadMinimaleEisenPerInfrastructuur(infrastructuurId) {
	return (dispatch) => {
		dispatch(ajax.started());

		return minimaleEisenPerInfrastructuurApi.get(infrastructuurId)
			.then(response => {
				dispatch(ajax.ended());
				dispatch(minimaleEisenPerInfrastructuurLoaded(response.data.item, response.data.validationResults, response.data.hasValidationErrors));
				dispatch(beads.beadsLoaded(response.data.item.beadModels));
			})
			.catch(error => {
				dispatch(ajax.failed(error));
				dispatch(exception.throwException(error));
			});
	};
}

export function getMinimaleEisenPerInfrastructuur(infrastructuurId) {
	return (dispatch) => {
		dispatch(ajax.started());

		return minimaleEisenPerInfrastructuurApi.get(infrastructuurId)
			.then(response => {
				dispatch(ajax.ended());
				return response.data.item;
			})
			.catch(error => {
				dispatch(ajax.failed(error));
				dispatch(exception.throwException(error));
			});
	};
}

// ----------------------------------------------------------------------------
export function minimaleEisenPerInfrastructuurSaved(minimaleEisenPerInfrastructuur, errors, hasValidationErrors) {
	return {
		type: types.MINIMALE_EISEN_PER_INFRASTRUCTUUR_SAVED,
		body: {
			item: minimaleEisenPerInfrastructuur,
			errors: errors,
			hasValidationErrors
		}
	};
}

export function saveMinimaleEisenPerInfrastructuur(minimaleEisenPerInfrastructuur, documenten) {
	return (dispatch) => {
		dispatch(ajax.started());
		return minimaleEisenPerInfrastructuurApi.save(minimaleEisenPerInfrastructuur, documenten)
			.then((response) => {
				dispatch(ajax.ended());
				if (response.data.concurrencyException) {
					dispatch(minimaleEisenPerInfrastructuurSaved(response.data.item, response.data.validationResults, response.data.hasValidationErrors));
					return constants.HAS_CONCURRENCY_EXCEPTION;
				}

				if (response.data.hasValidationErrors) {
					dispatch(minimaleEisenPerInfrastructuurSaved(response.data.item, response.data.validationResults, response.data.hasValidationErrors));
					return constants.HAS_VALIDATION_ERRORS;
				}
				if (Object.keys(response.data.validationResults).length !== 0) {
					dispatch(minimaleEisenPerInfrastructuurSaved(response.data.item, response.data.validationResults, response.data.hasValidationErrors));
					dispatch(beads.beadsLoaded(response.data.item.beadModels));
					return constants.HAS_VALIDATION_ERRORS_SAVED;
				}

				dispatch(minimaleEisenPerInfrastructuurSaved(response.data.item, response.data.validationResults, response.data.hasValidationErrors));
				dispatch(beads.beadsLoaded(response.data.item.beadModels));
				return constants.SUCCESS;

			})
			.catch(error => {
				dispatch(ajax.failed(error));
				dispatch(exception.throwException(error));
			});
	};
}
